import React, { useRef } from "react";
import Header from "../../Components/Header/Header";
import CustomDropdown from "../../Components/DropDown/CustomDropdown";
import Autocomplete from 'react-google-autocomplete'
import Icons from "../../Constants/Icons";
import Colors from "../../Constants/Colors";
import { useState, useEffect } from "react";
import CustomPagination from "../../Components/CustomPagination/CustomPagination";
import UpcomingEventsScreen from "../../Components/CustomDashboardScreen/UpcomingEventsScreen";
import { useDispatch } from "react-redux";
import {
  setLoadingFalse,
  setLoadingTrue,
} from "../../Config/Actions/loadingActions";
import {
  apiCallGetAdminAllEvent,
  apiCallGetEventStatus,
  onAPiCallSearchAdminEvent,
  onAPiCallToggleEventFeatured,
  apiCallGetAllCities,
  apiCallGetAllStates,
  apiCallGetAllContreies
} from "../../Core/Apicall";
import EmptyData from "../../Components/EmptyData/EmptyData";
import UseDebounce from "../../Components/UseDebounce";
import { CustomCommonBox } from "../../Components/CustomCommonBox/CustomCommonBox";
import { useNavigate, useLocation } from "react-router-dom";
import { LocationFilter } from "./EventsManagement";

function AdminEvents() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const page = Number(new URLSearchParams(location.search).get("page")) || 1;


  const statusDropdownItem = ["All", "Activate", "Deactivate"];
  const [event, setEvent] = useState();
  const [searchValue, setSearchValue] = useState("");
  const [dropdownLabelSelect, setDropdownLabelSelect] = useState("All");
  const [initialPage, setInitialPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [totalActive, setTotalActive] = useState(0);
  const [totalInActive, setTotalInActive] = useState(0);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [searchByVenue, setSearchByVenue] = useState("");
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [locationFilters, setLocationFilters] = useState({
    country: "",
    state: "",
    city: ""
  });
  const PAGE_SIZE = 15

  useEffect(() => {
    setInitialPage(page - 1);
    if (searchValue) {
      searchFilterFunction({
        text: searchValue,
        page: page - 1,
        fromDate: startDate,
        toDate: endDate,
        country: locationFilters?.country || "",
        state: locationFilters?.state || "",
        city: locationFilters?.city || "",
        status: dropdownLabelSelect
      });
    } else {
      onApiEventTypeList(page - 1, dropdownLabelSelect);
    }
  }, [page]);



  const debouncedInput = UseDebounce(searchValue, 500);
  const handleSelect = (status) => {
    setDropdownLabelSelect(status);
    if (startDate == "" && endDate == "" && locationFilters?.country == "" && locationFilters?.state == "" && locationFilters?.city == "" && searchValue == "") {
      onApiEventTypeList(0, status);
    } else {
      searchFilterFunction({
        text: searchValue,
        page: 0,
        fromDate: startDate,
        toDate: endDate,
        country: locationFilters?.country || "",
        state: locationFilters?.state || "",
        city: locationFilters?.city || "",
        status: status
      });
    }
  };

  const isInitialRender = useRef(true);

  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }
    searchFilterFunction({
      text: searchValue,
      page: 0,
      fromDate: startDate,
      toDate: endDate,
      country: locationFilters?.country || "",
      state: locationFilters?.state || "",
      city: locationFilters?.city || "",
      status: dropdownLabelSelect
    });
  }, [debouncedInput]);

  const handleInputChange = (e) => {
    const searchText = e.target.value;
    setSearchValue(searchText);
  };

  const searchFilterFunction = async ({
    text = "",
    page = 0,
    fromDate = "",
    toDate = "",
    country = "",
    state = "",
    city = "",
    status = dropdownLabelSelect
  } = {}) => {
    dispatch(setLoadingTrue());
    const params = {
      status: status,
      searchQuery: text,
      offset: page + 1,
      limit: PAGE_SIZE,
    };
    if (fromDate) params.fromDate = fromDate;
    if (toDate) params.toDate = toDate;
    if (country) params.country = country;
    if (state) params.state = state;
    if (city) params.city = city;

    try {
      const res = await onAPiCallSearchAdminEvent(params);
      setEvent(res);
      setInitialPage(page);
      dispatch(setLoadingFalse());
    } catch (error) {
      dispatch(setLoadingFalse());
    }
  };


  const onApiEventTypeList = async (selectedPage,dropdownLabelSelect) => {
    dispatch(setLoadingTrue());
    const param = {
      status: dropdownLabelSelect,
      offset: selectedPage + 1,
      limit: PAGE_SIZE,
    };
    try {
      const response = await apiCallGetAdminAllEvent(param);
      setTotalCount(response?.allEvent);
      setTotalActive(response?.allActiveEvent);
      setTotalInActive(response?.allDeActiveEvent);
      setInitialPage(selectedPage ?? 0);
      setEvent(response);
      dispatch(setLoadingFalse());
    } catch (error) {
      console.error("Error fetching event types:", error);
      dispatch(setLoadingFalse());
    }
  };

  const handelEnabled = async (data) => {
    dispatch(setLoadingTrue());
    const param = {
      eventId: data.eventId,
      isEnabled: !data.isEnabled,
    };
    try {
      const res = await apiCallGetEventStatus(param);

      if (data.isEnabled) {
        setTotalActive((pre) => pre - 1);
        setTotalInActive((pre) => pre + 1);
      } else {
        setTotalActive((pre) => pre + 1);
        setTotalInActive((pre) => pre - 1);
      }

      setEvent((prevData) => {
        const updatedData = prevData.data.map((item) => {
          if (item.eventId === data.eventId) {
            return { ...item, isEnabled: !item.isEnabled };
          }
          return item;
        });
        return { ...prevData, data: updatedData };
      });
      dispatch(setLoadingFalse());
    } catch (error) {
      dispatch(setLoadingFalse());
    }
  };

  const onClickFeaturedStatus = async (data) => {
    dispatch(setLoadingTrue());
    const param = {
      eventId: data.eventId,
      isFeatured: !data.isFeatured,
    };
    try {
      const res = await onAPiCallToggleEventFeatured(param);
      setEvent((prevData) => {
        const updatedData = prevData.data.map((item) => {
          if (item.eventId === data.eventId) {
            return { ...item, isFeatured: !item.isFeatured };
          }
          return item;
        });
        return { ...prevData, data: updatedData };
      });
      dispatch(setLoadingFalse());
    } catch (error) {
      dispatch(setLoadingFalse());
    }
  };
  const handleAddEvent = () => {
    navigate('/EventUpdate', { state: { AdminEvent: true } })
  }
  const onClickTabOpen = () => { };

  // Format date for display
  const formatDateDisplay = (dateString) => {
    if (!dateString) return "DD --- YYYY";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "DD --- YYYY";
    const day = String(date.getDate()).padStart(2, '0');
    const month = date.toLocaleString('default', { month: 'short' });
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  // Check if date is selected
  const isDateSelected = (dateString) => {
    return dateString && dateString.length > 0;
  };

  // Handle date change with auto-search
  const handleDateChange = (type, value) => {
    if (type === 'from') {
      setStartDate(value);
      // If both dates are selected, trigger search
      if (value && endDate) {
        searchFilterFunction({
          text: searchValue,
          page: 0,
          fromDate: value,
          toDate: endDate,
          country: locationFilters?.country || "",
          state: locationFilters?.state || "",
          city: locationFilters?.city || "",
          status: dropdownLabelSelect
        });
      }
    } else {
      setEndDate(value);
      // If both dates are selected, trigger search
      if (value && startDate) {
        searchFilterFunction({
          text: searchValue,
          page: 0,
          fromDate: startDate,
          toDate: value,
          country: locationFilters?.country || "",
          state: locationFilters?.state || "",
          city: locationFilters?.city || "",
          status: dropdownLabelSelect
        });
      }
    }
  };

  const handleClearDates = () => {
    setStartDate("");
    setEndDate("");
    setIsDatePickerOpen(false);
    // Trigger search with empty dates to reset
    searchFilterFunction({
      text: searchValue,
      page: 0,
      fromDate: "",
      toDate: "",
      country: locationFilters?.country || "",
          state: locationFilters?.state || "",
          city: locationFilters?.city || "",
          status: dropdownLabelSelect
    });
  };

  return (
    <div>
      <Header name={"Admin Events"} />
      <div className="Event-AlignSelf">
        <div className="lastWeekEndDiv Event-AlignSelf-stretch">
          <div className="astrologer-inner">
            <div className="frame-container">
              <div className="frame-div">
                {[
                  { label: "Total Admin Events", color: "", count: totalCount },
                  {
                    label: "Total Admin Activate",
                    color: Colors.darkGreen,
                    count: totalActive,
                  },
                  {
                    label: "Total Admin Deactivate",
                    color: Colors.darkBlue,
                    count: totalInActive,
                  },
                ].map((items, index) => (
                  <CustomCommonBox
                    key={index.toString()}
                    label={items.label}
                    color={items.color}
                    count={items.count}
                    onClickTabOpen={onClickTabOpen}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="astrologers-list-parent padding-top-bottom ">
        <div className="frame-parent2">
          <div className="custom-box-user">
            <div className='category_button'>
              <button onClick={handleAddEvent}>Create Event</button>
            </div>
            <div className="custom-container-dropdown-div">
              <CustomDropdown
                dropDownLabel={dropdownLabelSelect}
                items={statusDropdownItem}
                color="blue"
                onSelect={handleSelect}
                customLabelStyle={{
                  fontWeight: "400",
                  color: "white",
                }}
              />
            </div>

            <div className="custom-box-search-div">
              <img className="custom-image" alt="" src={Icons.ic_search} />
              <input
                type="text"
                className="searchTextInput"
                placeholder="Search"
                value={searchValue}
                onChange={handleInputChange}
              />
            </div>
            <LocationFilter
              searchValue={searchValue}
              startDate={startDate}
              endDate={endDate}
              onSearch={searchFilterFunction}
            />


            <div className="date-range-wrapper">
              <div
                className={`custom-box-search-div ${isDatePickerOpen ? 'active' : ''}`}
                onClick={() => setIsDatePickerOpen(!isDatePickerOpen)}
                style={{ minWidth: "300px" }}
              >
                <div className="date-range-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 10H21M7 3V5M17 3V5M6 2H18C19.1046 2 20 2.89543 20 4V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V4C4 2.89543 4.89543 2 6 2Z"
                      stroke="#e28d25" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M8 14H10M10 14H12M12 14H14M14 14H16M8 18H10M10 18H12M12 18H14M14 18H16"
                      stroke="#e28d25" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <span className="date-range-text">
                  <span className="date-label">From</span>
                  <span className={`date-value ${!isDateSelected(startDate) ? 'empty' : ''}`}>
                    {formatDateDisplay(startDate)}
                  </span>
                  <span className="date-separator">→</span>
                  <span className="date-label">To</span>
                  <span className={`date-value ${!isDateSelected(endDate) ? 'empty' : ''}`}>
                    {formatDateDisplay(endDate)}
                  </span>
                </span>
                <div className={`date-range-arrow ${isDatePickerOpen ? 'open' : ''}`}>
                  <svg width="10" height="10" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1.5L6 6.5L11 1.5" stroke="#e28d25" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
              </div>

              {isDatePickerOpen && (
                <div className="date-picker-dropdown">
                  <div className="date-picker-container">
                    <div className="date-picker-group">
                      <label className="date-picker-label">From Date</label>
                      <input
                        type="date"
                        className="date-picker-input"
                        value={startDate}
                        onChange={(e) => handleDateChange('from', e.target.value)}
                      />
                    </div>
                    <div className="date-picker-divider"></div>
                    <div className="date-picker-group">
                      <label className="date-picker-label">To Date</label>
                      <input
                        type="date"
                        className="date-picker-input"
                        value={endDate}
                        onChange={(e) => handleDateChange('to', e.target.value)}
                      />
                    </div>
                    <div className="date-picker-divider"></div>

                  </div>
                </div>
              )}
            </div>

          </div>
        </div>
      </div>
      <div className="Event-custom-style">
        <div className="lastWeekEndDiv Event-AlignSelf-stretch">
          <div className="user_title event-flex-container">
            Admin Events list
          </div>

          <div className="upcoming_list">
            <div className="Achievements-class-name">
              <div className="achievement-content">
                <div className="achievement-content-header">
                  <div className="lastWeekEndDivGreyColor w-8">image</div>
                  <div className="lastWeekEndDivGreyColor w-10">Name</div>
                  <div className="lastWeekEndDivGreyColor w-22">
                    Events Name
                  </div>

                  <div className="lastWeekEndDivGreyColor w-30">
                    Date & times
                  </div>
                  <div className="lastWeekEndDivGreyColor w-10">Actions</div>
                  <div className="lastWeekEndDivGreyColor w-10">Status</div>
                  <div className="lastWeekEndDivGreyColor w-10">Cancel</div>

                  <div className="lastWeekEndDivGreyColor w-10">Featured</div>
                </div>
                <div className="scrollable-container transform_data ">
                  <UpcomingEventsScreen
                    adminEventEdit={true}
                    cancel={true}
                    handelEnabled={handelEnabled}
                    onClickFeaturedStatus={onClickFeaturedStatus}
                    data={event?.data}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {event?.data.length == 0 && (
        <div className="empty-centered">
          <EmptyData />
        </div>
      )}
      {event?.data.length != 0 && (
        <div className="Custom-Pagination">
          <CustomPagination
            pageCount={Math.ceil((event?.totalCount || 0) / PAGE_SIZE)}
            pageRangeDisplayed={3}
            initialPage={initialPage}
            marginPagesDisplayed={1}
            onPageChange={({ selected }) => {
              setInitialPage(selected);
              navigate(`/AdminEvents?page=${selected + 1}`);
             if (startDate == "" && endDate == "" && locationFilters?.country == "" && locationFilters?.state == "" && locationFilters?.city == "" && searchValue == "") {
                onApiEventTypeList(selected, dropdownLabelSelect);
              } else {
                searchFilterFunction({
                  text: searchValue,
                  page: selected,
                  fromDate: startDate,
                  toDate: endDate,
                  country: locationFilters?.country || "",
                  state: locationFilters?.state || "",
                  city: locationFilters?.city || "",
                  status: dropdownLabelSelect
                });
              }
            }}
          />
        </div>
      )}
    </div>
  );
}
export default AdminEvents;
